import Tabs from "./Tabs";

export default class extends Tabs {
    constructor(m) {
        super(m);
    }

    init() {
        this.initTabs()
        this.bindEvents()
    }

    start() {        
        this.setSelectedTab(this.$firstTab)            
    }

    setSelectedTab($currentTab) {
        super.setSelectedTab($currentTab);

        const slug = this.getData('slug', $currentTab);
        this.call('setLabels', slug, 'ExploreScene')
    }

    setSelectedTabBySlug(slug) {
        const $tab = this.$tabs.find(tab => {
            return slug == this.getData('slug', tab);
        })

        this.setSelectedTab($tab)
    }
}
